module.exports = __webpack_public_path__ + "img/icon5.4bd7ac76.png";